export default __webpack_public_path__ + "static/media/icon-share-via-email.510578dd.svg";